const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

export function formatDollars(dollars: number): string {
  return formatter.format(dollars);
}
